/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type KillswitchesListCapabilitiesSecurity = {
  sessionHeaderGramSession: string;
};

export type KillswitchesListCapabilitiesRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type KillswitchesListCapabilitiesSecurity$Outbound = {
  "session_header_Gram-Session": string;
};

/** @internal */
export const KillswitchesListCapabilitiesSecurity$outboundSchema: z.ZodMiniType<
  KillswitchesListCapabilitiesSecurity$Outbound,
  KillswitchesListCapabilitiesSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function killswitchesListCapabilitiesSecurityToJSON(
  killswitchesListCapabilitiesSecurity: KillswitchesListCapabilitiesSecurity,
): string {
  return JSON.stringify(
    KillswitchesListCapabilitiesSecurity$outboundSchema.parse(
      killswitchesListCapabilitiesSecurity,
    ),
  );
}

/** @internal */
export type KillswitchesListCapabilitiesRequest$Outbound = {
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const KillswitchesListCapabilitiesRequest$outboundSchema: z.ZodMiniType<
  KillswitchesListCapabilitiesRequest$Outbound,
  KillswitchesListCapabilitiesRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function killswitchesListCapabilitiesRequestToJSON(
  killswitchesListCapabilitiesRequest: KillswitchesListCapabilitiesRequest,
): string {
  return JSON.stringify(
    KillswitchesListCapabilitiesRequest$outboundSchema.parse(
      killswitchesListCapabilitiesRequest,
    ),
  );
}
